module.exports = __webpack_public_path__ + "static/media/d4p.8c435b8c.jpg";